import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

import './infraestructure.css'

function Info(props) {
  return (
    <div>
      <IconButton
        // variant="contained"
        // className={classes.modalBtn}
        onClick={() => props.closeModal()}
        size="small"
        style={{ position: 'absolute', top: '0px', right: '0px', borderRadius: '0 0 0 5px' }}
      >
        <CloseIcon />
      </IconButton>
      <h3 style={{ marginTop: '0px', fontWeight: 'bold' }}>{props.data.title}</h3>
      <p
        style={{
          textAlign: 'justify',
          padding: '10px',
          background: '#e8e8e8',
          borderRadius: '5px',
        }}
      >
        {props.data.description}
      </p>

      {props.data.table.map((table) => (
        <div>
          <h5
            style={{
              marginTop: '0px',
              fontWeight: 'bold',
              padding: '10px',
              background: '#e8e8e8',
              borderRadius: '5px',
              color: '#868686',
            }}
          >
            {table.name}
          </h5>
          <div style={{ display: 'flex' }}>
            <div
              style={{
                flexGrow: '1',
                marginBottom: '5px',
                padding: '10px',
                borderRight: 'solid 1px #dfdfdf',
                width: '60%',
              }}
            >
              <h5 style={{ fontWeight: 'bold' }}>Description</h5>
              {Array.isArray(table.description) ? (
                table.description.map((descriptions) => (
                  <p style={{ textAlign: 'justify', fontSize: '12px', whiteSpace: 'pre-line' }}>{descriptions}</p>
                ))
              ) : (
                <p style={{ textAlign: 'justify', fontSize: '12px', whiteSpace: 'pre-line' }}>{table.description}</p>
              )}
            </div>

            <div
              style={{
                flexGrow: '1',
                marginBottom: '5px',
                padding: '10px',
                borderRight: 'solid 1px #dfdfdf',
                width: '25%',
              }}
            >
              <h5 style={{ fontWeight: 'bold' }}>Sources</h5>
              {Array.isArray(table.sources) ? (
                table.sources.map((source) => <p style={{ textAlign: 'justify', fontSize: '12px' }}>{source}</p>)
              ) : (
                <p style={{ textAlign: 'justify', fontSize: '12px', whiteSpace: 'pre-line' }}>{table.sources}</p>
              )}
            </div>

            <div style={{ flexGrow: '1', marginBottom: '5px', padding: '10px', width: '15%' }}>
              <h5 style={{ fontWeight: 'bold' }}>Last Update</h5>
              {Array.isArray(table.date) ? (
                table.date.map((dates) => (
                  <p style={{ textAlign: 'left', fontSize: '12px', whiteSpace: 'pre-line' }}>{dates}</p>
                ))
              ) : (
                <p style={{ textAlign: 'left', fontSize: '12px', whiteSpace: 'pre-line' }}>{table.date}</p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Info
